/**
 * A link out of the game to a page on the public site (`/rules`, `/privacy`, `/terms`, `/discord`).
 *
 * On the web it is a plain anchor. `newTab` is for places a table may be live behind the link
 * (Settings, the end-of-match panel): following it in the same tab would drop the player's seat.
 * Inside Discord the site cannot be browsed in the Activity iframe, so the click goes through the
 * bridge's `openExternalLink`, which is Discord's own "leaving Discord" confirmation and a browser.
 */
import type { ReactNode } from 'react';
import { isEmbedded } from '../../bridge/embedded';
import { siteUrl } from '../paths';
import { getRuntime } from '../runtime';

export interface SiteLinkProps {
  path: string;
  className?: string;
  newTab?: boolean;
  testId?: string;
  children: ReactNode;
}

export function SiteLink({ path, className, newTab, testId, children }: SiteLinkProps) {
  const embedded = isEmbedded();
  const href = siteUrl(path);
  if (embedded) {
    return (
      <a
        className={className}
        href={href}
        data-testid={testId}
        onClick={(e) => {
          e.preventDefault();
          void getRuntime()?.bridge.openExternalLink(href).catch(() => {});
        }}
      >
        {children}
      </a>
    );
  }
  return (
    <a className={className} href={href} data-testid={testId} {...(newTab ? { target: '_blank', rel: 'noopener' } : {})}>
      {children}
    </a>
  );
}
